import React, { useState } from 'react';
import { observer } from 'src/utils/mobx-react';
import { PaysafeTabState } from 'src/domains/players/webview/components/WithdrawAndDeposit/depositProcedure/multiDepositJourney/PaysafeTab/PaysafeTab.state';
import { MultiDepositSteps } from 'src/domains/players/webview/components/WithdrawAndDeposit/depositProcedure/multiDepositJourney/MultiDepositSteps.state';
import { PaysafeFrame } from 'src/domains/players/webview/components/WithdrawAndDeposit/depositProcedure/paysafeProvider/paysafeFrame/PaysafeFrame';
import { DepositTabWrapper } from 'src/domains/players/webview/components/WithdrawAndDeposit/depositProcedure/DepositProcedure.style';
import { useCommon } from 'src/domains/common/Common';
import { DepositErrorMessagesState } from 'src/domains/players/webview/components/WithdrawAndDeposit/depositProcedure/topUpProcedureParts/errorMessages/DepositErrorMessages.state';
import { PaysafeLoaderWrapper } from 'src/domains/players/webview/components/WithdrawAndDeposit/depositProcedure/multiDepositJourney/PaysafeTab/PaysafeTab.style';

interface PaysafeTabPropsType {
    amount: string;
    stepsState: MultiDepositSteps;
    isSignup: boolean;
    errorMessagesState: DepositErrorMessagesState;
}

export const PaysafeTab = observer(
    'PaysafeTab',
    ({ amount, stepsState, isSignup, errorMessagesState }: PaysafeTabPropsType): JSX.Element => {
        const common = useCommon();
        const [paysafeState] = useState(
            () => new PaysafeTabState(common, amount, stepsState, isSignup, errorMessagesState)
        );

        if (paysafeState.isLoading === false && paysafeState.paymentIframeData !== null) {
            return (
                <DepositTabWrapper>
                    <PaysafeFrame
                        paymentIframeData={paysafeState.paymentIframeData}
                        paysafeTabState={paysafeState}
                        paysafePaymentProvider={paysafeState.paysafePaymentProviderConfig}
                    />
                </DepositTabWrapper>
            );
        }

        return (
            <DepositTabWrapper>
                <PaysafeLoaderWrapper size={24} />
            </DepositTabWrapper>
        );
    }
);
